import { Link, useHistory } from 'react-router-dom';
import { Cancel as CancelIcon, Search as SearchIcon } from '@vgno/icons';

import { Button } from '../../Button/Button';
import { getPath, routeNames } from '../../../shared/helpers/routes';

import type { FC } from 'react';

interface SearchButtonProps {
  active?: boolean;
  className?: string;
}

export const SearchButton: FC<SearchButtonProps> = ({ active, className }) => {
  const history = useHistory();

  if (active) {
    return (
      <Button
        variant="text"
        className={className}
        onClick={() => {
          if (history.location.key) {
            history.goBack();
          } else {
            history.push('/');
          }
        }}
      >
        <CancelIcon />
      </Button>
    );
  }

  return (
    <Button
      component={Link}
      variant="text"
      to={getPath(routeNames.search)}
      className={className}
    >
      <SearchIcon />
    </Button>
  );
};
